export default "__VITE_ASSET__Dfeocj____"